import axios from 'axios';

const apiBaseUrl = process.env.REACT_APP_API_URL || 'https://api.iskenderun.bel.tr/api';
const baseUrl = `${new URL(apiBaseUrl).origin}/`;

export const getSlidersByPageCode = async (pageCode) => {
    try {
        const response = await axios.post(`${baseUrl}GetSlidersByPageCode`, {
            pageCode: pageCode
        });
        return response.data;
    } catch (error) {
        console.error('Slider verisi alınırken hata:', error);
        throw error;
    }
};
